import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CommonInputComponent } from '../../shared/components/common-input/common-input.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from '../../core/services/cookie/cookie.service';
import { resetPasswordRequest } from '../../state/actions/createPasswordAction';

@Component({
  selector: 'app-change-password-modal',
  standalone: true,
  imports: [
    CommonInputComponent,
    ButtonComponent,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './change-password-modal.component.html',
  styleUrl: './change-password-modal.component.scss',
})
export class ChangePasswordModalComponent {
  changePasswordForm: FormGroup;
  isSubmit: boolean = false;
  data = inject<any>(MAT_DIALOG_DATA, { optional: true }) || {};
  passwordErrors: ('normal' | 'success' | 'failed')[] = [
    'normal',
    'normal',
    'normal',
    'normal',
    'normal',
  ];

  constructor(
    private store: Store,
    private cookie: CookieService,
    private dialogRef: MatDialogRef<ChangePasswordModalComponent>,
  ) {
    this.changePasswordForm = new FormGroup({
      newPassword: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    if (this.dialogRef) {
      this.dialogRef.updateSize('720px');
    }
    this.changePasswordForm
      .get('newPassword')
      ?.valueChanges.subscribe((value) => {
        this.validatePassword(value);
      });
  }

  validatePassword(password: string): void {
    const minLength = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar =
      /[~!@#$%^&*()_+\-=]/.test(password) &&
      !/[^A-Za-z\d~!@#$%^&*()_+\-=]/.test(password);
    this.passwordErrors = [
      minLength ? 'success' : 'failed',
      hasUpperCase ? 'success' : 'failed',
      hasLowerCase ? 'success' : 'failed',
      hasNumber ? 'success' : 'failed',
      hasSpecialChar ? 'success' : 'failed',
    ];
  }

  getPasswordErrorMessage(index: number): string {
    const messages = [
      'Be at least 8 characters long',
      'Have at least one upper case',
      'Have at least one lower case',
      'Have at least one number',
      'Have at least one special character (~!@#$%^&*()_+-=)',
    ];
    return messages[index];
  }

  isPasswordValid(): boolean {
    // Check if all password errors are 'success'
    return this.passwordErrors.every((error) => error === 'success');
  }

  onCancel(event?: KeyboardEvent) {
    if (event && event.key === 'Enter') {
      event.preventDefault();
      this.dialogRef.close();
    } else if (!event) {
      this.dialogRef.close();
    }
  }

  onSubmit() {
    this.isSubmit = true;
    if (this.changePasswordForm.valid) {
      if (
        this.changePasswordForm.value.newPassword ===
        this.changePasswordForm.value.confirmPassword
      ) {
        const payload: any = {
          sessionHash: this.cookie.getItem('sessionHash') || '',
          password: this.changePasswordForm?.value?.newPassword,
        };
        this.store.dispatch(
          resetPasswordRequest({ createPasswordParams: payload }),
        );
        this.dialogRef.close();
      }
    }
  }
}
